import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import React from 'react'
import { ICheckboxCard } from './ICheckboxCard'

const CheckboxCard = ({ cheked, onChange, disable = false, checkboxTitle, checkboxTitleDetail, moreDetail, style, installmentNo }: ICheckboxCard) => {
    return (
        <Grid onClick={() => !disable && onChange && onChange({ target: { checked: !cheked } } as any)} container className='py-3' justifyContent={"space-between"} alignItems={'center'} sx={{
            borderRadius: "5px", background: "var(--input-bg-color)", paddingLeft: "20px", opacity: disable ? '0.7' : '1'
        }} style={style}>
            <Grid item>
                <FormControlLabel
                    // key={index}
                    // className="contract-formLable"
                    // required
                    disabled={disable}
                    control={
                        <Checkbox
                            onChange={onChange}
                            sx={{
                                color: '#D7DBEC',
                                '&.Mui-checked': {
                                    color: '#BBA57A',
                                },
                            }}
                            checked={cheked}
                        />
                    }
                    label={
                        moreDetail &&
                        <Grid item className='flex !flex-col' sx={{ fontSize: ".9rem", color: "var(--primary-text-color)" }}>
                            <span className='text-xs'> قسط {installmentNo}</span>
                            <span>
                                {moreDetail}

                            </span>
                        </Grid>
                    }
                />
            </Grid>
            {
                <Grid item className='flex !flex-col' sx={{ fontSize: ".9rem", color: "var(--primary-text-color)" }}>
                    {checkboxTitle}
                    <span></span>
                    <span className='text-[#FF617C] text-xs'>
                        {checkboxTitleDetail > 0 && `${checkboxTitleDetail.toLocaleString("fa-IR")} ریال`}

                    </span>

                </Grid>}
        </Grid>
    )
}

export default CheckboxCard